import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useLogout, useSession } from '../auth/useSession.js';

export function SignedInAs() {
  const session = useSession();
  const logout = useLogout();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  if (!session.data) return null;

  return (
    <p>
      Signed in as <strong>{session.data.email}</strong>{' '}
      <button
        type="button"
        onClick={() =>
          logout.mutate(undefined, {
            onSuccess: async () => {
              await queryClient.invalidateQueries();
              navigate('/login', { replace: true });
            },
          })
        }
        disabled={logout.isPending}
      >
        Sign out
      </button>
    </p>
  );
}
